import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Box } from '../../components/Box/index.js';
import { getAlignY } from '../../components/Spread/utils/getAlignY.js';
/**
 * If you’d like to spread components to opposite ends of a container while
 * maintaining a minimum amount of space in between them, we provide the Spread
 * component.
 */
export const Spread = /*#__PURE__*/_styled(({
  children,
  space = 0,
  align,
  alignY,
  direction = 'horizontal',
  ...restProps
}) => {
  return _jsx(Box, {
    display: "flex",
    gap: space,
    justifyContent: "space-between",
    flexDirection: direction === 'vertical' ? 'column' : 'row',
    alignItems: direction === 'vertical' ? align : getAlignY(alignY),
    height: direction === 'vertical' ? '100%' : undefined,
    ...restProps,
    children: children
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e141cni10"
} : {
  target: "e141cni10",
  label: "Spread"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNwcmVhZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXRyIsImZpbGUiOiJTcHJlYWQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgQm94IH0gZnJvbSAnLi4vLi4vY29tcG9uZW50cy9Cb3gvaW5kZXguanMnO1xuaW1wb3J0IHsgZ2V0QWxpZ25ZIH0gZnJvbSAnLi4vLi4vY29tcG9uZW50cy9TcHJlYWQvdXRpbHMvZ2V0QWxpZ25ZLmpzJztcbi8qKlxuICogSWYgeW914oCZZCBsaWtlIHRvIHNwcmVhZCBjb21wb25lbnRzIHRvIG9wcG9zaXRlIGVuZHMgb2YgYSBjb250YWluZXIgd2hpbGVcbiAqIG1haW50YWluaW5nIGEgbWluaW11bSBhbW91bnQgb2Ygc3BhY2UgaW4gYmV0d2VlbiB0aGVtLCB3ZSBwcm92aWRlIHRoZSBTcHJlYWRcbiAqIGNvbXBvbmVudC5cbiAqL1xuZXhwb3J0IGNvbnN0IFNwcmVhZCA9IHN0eWxlZCgoeyBjaGlsZHJlbiwgc3BhY2UgPSAwLCBhbGlnbiwgYWxpZ25ZLCBkaXJlY3Rpb24gPSAnaG9yaXpvbnRhbCcsIC4uLnJlc3RQcm9wcyB9KSA9PiB7XG4gICAgcmV0dXJuIChfanN4KEJveCwgeyBkaXNwbGF5OiBcImZsZXhcIiwgZ2FwOiBzcGFjZSwganVzdGlmeUNvbnRlbnQ6IFwic3BhY2UtYmV0d2VlblwiLCBmbGV4RGlyZWN0aW9uOiBkaXJlY3Rpb24gPT09ICd2ZXJ0aWNhbCcgPyAnY29sdW1uJyA6ICdyb3cnLCBhbGlnbkl0ZW1zOiBkaXJlY3Rpb24gPT09ICd2ZXJ0aWNhbCcgPyBhbGlnbiA6IGdldEFsaWduWShhbGlnblkpLCBoZWlnaHQ6IGRpcmVjdGlvbiA9PT0gJ3ZlcnRpY2FsJyA/ICcxMDAlJyA6IHVuZGVmaW5lZCwgLi4ucmVzdFByb3BzLCBjaGlsZHJlbjogY2hpbGRyZW4gfSkpO1xufSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1TcHJlYWQuanMubWFwIl19 */");